@use 'src/globals/main';

pn-button-dropdown {
  display: inline-block;
  position: relative;
}
pn-button-dropdown .pn-button-dropdown {
  &-container {
    z-index: 10;
    position: absolute;

    top: 130%;
    left: 0;

    background-color: main.$white;
    border-radius: 1em;
    box-shadow: 0 0.125em 1em rgba(0, 0, 0, 0.2);
    overflow-y: auto;

    max-width: 95vw;
    max-width: min(95vw, 40em);
    max-height: 80vh;

    transform: scale(0);
    transform-origin: top left;
    @include main.pn-transition('transform');
    transition-delay: main.$timing;

    &[data-right] {
      left: unset;
      right: 0;
      transform-origin: top right;
    }

    &[data-top] {
      top: unset;
      bottom: 130%;
      transform-origin: bottom left;
    }
  }

  &-content {
    position: relative;
    padding: 1em;
    opacity: 0;
    width: max-content;
    max-width: 100%;
    visibility: hidden;

    @include main.pn-transition('opacity, visibility');
    transition-delay: 0s, main.$timing;
  }

  &[data-open='true'] {
    .pn-button-dropdown-container {
      transition-delay: 0s;
    }
    .pn-button-dropdown-content {
      opacity: 1;
      visibility: visible;
    }
  }
}
